'use client';

import React from 'react';
import { Arr, DebounceClosure, DebouncedFunction, leadingCancelableThrottle } from '@benzinga/utils';

export const useThrottleLeading = <T extends DebouncedFunction<E>, E extends Arr = Parameters<T>>(
  debouncedFunc: T,
  maxWait: number,
): DebounceClosure<T, E> => {
  const [fn, cancel] = React.useMemo(
    () => leadingCancelableThrottle<T, E>(debouncedFunc, maxWait),
    [debouncedFunc, maxWait],
  );
  React.useEffect(() => {
    return () => cancel();
  }, [cancel]);

  return fn;
};
